import script from "./PayWay.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayWay.vue?vue&type=script&lang=ts&setup=true"

import "./PayWay.vue?vue&type=style&index=0&id=e7d70898&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7d70898"]])

export default __exports__